import React from 'react';
import {Carousel} from 'antd';
import {WingBlank} from '../../components';
import './Banner.less';

const isIE = () => {
  if (global.navigator) {
    return navigator.userAgent.includes('MSIE');
  } else {
    return false;
  }
};

function BannerItem({img, title, description}) {
  return (
    <div data-role='BannerItem'>
      <div>
        <div>
          <h1>{title}</h1>
          <div>{description}</div>
        </div>
        <div>
          <img src={img} alt='image' />
        </div>
      </div>
    </div>
  );
}

function Banner({data}) {
  return (
    <WingBlank className='HomeBanner'>
      <Carousel effect={isIE() ? 'scrollx' : 'fade'} autoplay>
        {data.map((item, index) => <BannerItem {...item} key={index}/>)}
      </Carousel>
    </WingBlank>
  );
}

export default Banner;


// WEBPACK FOOTER //
// ./src/routes/Home/Banner.js